import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ArrowDropDownIcon from '@material-ui/icons/KeyboardArrowDown'

function LabelSelect(props) {
  //Values from client
  const {
    FollowTheFlow,
    coordinateArray,
    isVerifyMode,
    isPractice,
    Completed,
    isActive,
    priorityActive,
    explanationClick,
    optionsArray,
    isAudioPlaying
  } = props

  //Values to client
  const {
    isImageLoaded,
    setSelectedBox,
    handleExplanationChange,
    onOptionSelect
  } = props
  const [boxFocused, setBoxFocused] = useState(-1)
  const [isDropdown, setIsDropdown] = useState(false)

  function renderDropdownUI(optionIndex, y, CorrectAnswer, Height, Priority) {
    let yInt = parseFloat(y.split('%')[0])
    return (
      <div
        className='dropdown-content card-shadow'
        style={{
          bottom: yInt > 70 ? '100%' : undefined,
          top: yInt > 70 ? undefined : '100%'
        }}
      >
        {optionsArray[optionIndex] &&
          optionsArray[optionIndex].map((l, index) => (
            <span
              className='dropdown-list-label-container'
              style={{
                cursor: 'pointer'
              }}
              key={index.toString()}
              onClick={(ev) => {
                setBoxFocused(-1)
                setSelectedBox(undefined)
                setIsDropdown(false)
                onOptionSelect(
                  l.CorrectAnswer,
                  CorrectAnswer,
                  optionIndex,
                  Priority
                )
              }}
            >
              <p className='dropdown-list-label'>{l.CorrectAnswer}</p>
            </span>
          ))}
      </div>
    )
  }

  useEffect(() => {
    console.log('boxFocused', boxFocused)
  }, [boxFocused])

  return (
    <span
      style={{
        width: '100%',
        height: '100%',
        zIndex: 90
      }}
    >
      {isImageLoaded &&
        coordinateArray.map((box, index) => {
          const {
            ControlID,
            XAxis,
            YAxis,
            FontSize,
            Rotation,
            Weight,
            Width,
            CorrectAnswer,
            defaultValue,
            Height,
            Priority
          } = box
          const isCorrectAnswer = box.defaultValue === box.CorrectAnswer
          return (
            <div
              // className={
              //   defaultValue !== ''
              //     ? isPractice || Completed === 1 || !isActive
              //       ? box.defaultValue === box.CorrectAnswer
              //         ? 'input-box correct-answer'
              //         : 'input-box wrong-answer'
              //       : 'input-box normal-input'
              //     : 'input-box normal-input'
              // }
              className={
                Completed === 1 || !isActive
                  ? isCorrectAnswer
                    ? 'input-box correct-answer'
                    : 'input-box wrong-answer'
                  : isPractice
                  ? FollowTheFlow
                    ? Priority === priorityActive
                      ? defaultValue === ''
                        ? 'input-box normal-input'
                        : boxFocused === ControlID
                        ? 'input-box active-input'
                        : isCorrectAnswer
                        ? 'input-box correct-answer'
                        : 'input-box wrong-answer'
                      : Priority < priorityActive
                      ? isCorrectAnswer
                        ? 'input-box correct-answer'
                        : 'input-box wrong-answer'
                      : 'input-box inactive-input'
                    : defaultValue === ''
                    ? 'input-box normal-input'
                    : boxFocused === ControlID
                    ? 'input-box active-input'
                    : isCorrectAnswer
                    ? 'input-box correct-answer'
                    : 'input-box wrong-answer'
                  : defaultValue === ''
                  ? 'input-box normal-input'
                  : boxFocused === ControlID
                  ? 'input-box active-input'
                  : 'input-box active-input'
              }
              // className={
              //   defaultValue !== ''
              //     ? isPractice || Completed === 1 || !isActive
              //       ? box.defaultValue === box.CorrectAnswer
              //         ? 'green-box'
              //         : 'red-box'
              //       : 'black-box'
              //     : 'black-box'
              // }
              style={{
                position: 'absolute',
                top: YAxis,
                left: XAxis,
                transform:
                  isDropdown && boxFocused === ControlID
                    ? `rotate(0deg)`
                    : `rotate(${Rotation})`,
                transformOrigin: '0px 0px',
                minWidth: '11.5%',
                width: Width.concat('%'),
                height: Height.concat('%'),
                // display: FollowTheFlow
                //   ? priorityActive && Priority <= priorityActive
                //     ? 'flex'
                //     : 'none'
                //   : 'flex',
                fontSize: FontSize,
                pointerEvents:
                  explanationClick ||
                  Completed === 1 ||
                  !isActive ||
                  isAudioPlaying
                    ? 'none'
                    : isPractice && FollowTheFlow
                    ? box.defaultValue === box.CorrectAnswer
                      ? 'none'
                      : 'auto'
                    : 'auto',
                cursor: 'pointer',
                zIndex: isDropdown && boxFocused === ControlID ? 1 : 0,
                backgroundColor: 'white',
                boxShadow:
                  box.BoxOverlay &&
                  `${box.BoxOverlay.shadowColorValue} 0px 0px ${box.BoxOverlay.shadowOpacity}px ${box.BoxOverlay.shadowSpread}px`
              }}
              onClick={() => {
                if (explanationClick) {
                  if (box.defaultValue === box.CorrectAnswer) {
                    handleExplanationChange(true, box.CorrectAnswerExplanation)
                  } else {
                    handleExplanationChange(
                      false,
                      box.IncorrectAnswerExplanation
                    )
                  }
                }
                if (boxFocused < 0) {
                  setBoxFocused(ControlID)
                  setSelectedBox(box)
                  setIsDropdown(true)
                } else {
                  setBoxFocused(-1)
                  setSelectedBox(undefined)
                  setIsDropdown(false)
                }
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
              >
                <div
                  style={{
                    width: '90%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '2%',
                    overflow: 'hidden'
                  }}
                >
                  <p
                    style={{
                      width: '100%',
                      margin: 0,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden'
                    }}
                  >
                    {isVerifyMode ? CorrectAnswer : defaultValue}
                  </p>
                </div>
                <div
                  style={{
                    width: '10%',
                    height: '100%',
                    display: 'contents'
                  }}
                >
                  <ArrowDropDownIcon
                    style={{
                      width: '30px',
                      height: '30px',
                      alignSelf: 'center',
                      color: '#A8A8A8'
                    }}
                  />
                </div>
              </div>
              {isDropdown &&
                boxFocused &&
                boxFocused === ControlID &&
                renderDropdownUI(index, YAxis, CorrectAnswer, Height, Priority)}
            </div>
          )
        })}
    </span>
  )
}

export { LabelSelect }
